import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Card, Form, Breadcrumb } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, useParams } from 'react-router-dom'; // Assuming React Router is used
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from "primereact/inputtext";
import { Accordion, AccordionTab } from 'primereact/accordion';
import GifLoder from '../../components/GifLoder';
import crossVideo from '../../assets/video/cross.mp4';

const Edit_client = () => {
    const navigate = useNavigate();
    const { accessToken } = useAuth();
    const { clientId } = useParams(); // Extract clientId from the route params
    const [clientData, setClientData] = useState(null);
    const [clientDetails, setClientDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editMode, setEditMode] = useState(false);
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const toggleEditMode = () => {
        setEditMode(!editMode);
    };

    // Handle input changes in the form
    const handleInputChange = (index, field, value) => {
        const updatedDetails = [...clientDetails];
        updatedDetails[index][field] = value;
        setClientDetails(updatedDetails);
    };

    // Add a new ClientDetails entry
    const handleAddNewDetail = () => {
        if (editMode) {
            setClientDetails([
                ...clientDetails,
                {
                    comp_name: "",
                    poc: "",
                    gstin: "",
                    pan: "",
                    phone: "",
                    email: "",
                    bcc_emails: "",
                    cc_emails: "",
                    bill_name: "",
                    bill_address: "",
                },
            ]);
        }
    };

    const handleDeleteDetail = (index) => {
        const updatedDetails = [...clientDetails];
        updatedDetails.splice(index, 1);
        setClientDetails(updatedDetails);
    };



    // Handle form submission to update client details
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = { clientDetailsArray: clientDetails };
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const response = await axios.put(
                `${config.apiBASEURL}/ClientRoutes/edit-client-details/${clientId}`,
                payload,
                { headers }
            );

            if (response.status === 200) {
                setEditMode(false);
                fetchClientData();
            } else {
                setVideocrossDialogVisible(true); // Show video dialog

                setTimeout(() => {
                    setEditMode(false);
                    fetchClientData();
                    setVideocrossDialogVisible(false); // Hide video dialog after 6 seconds

                }, 5000);
            }
        } catch (err) {
            console.error('Error updating client details:', err);
            setVideocrossDialogVisible(true); // Show video dialog

            setTimeout(() => {
                setVideocrossDialogVisible(false); // Hide video dialog after 6 seconds
            }, 5000);
        }
    };



    const fetchClientData = async () => {
        setLoading(true);
        try {
            // Simulate a delay of 3 seconds
            await new Promise((resolve) => setTimeout(resolve, 3000));

            const response = await axios.get(`${config.apiBASEURL}/ClientRoutes/client/${clientId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setClientData(response.data);
            setClientDetails(response.data.ClientDetails || []);
        } catch (err) {
            console.error('Error fetching client data:', err);
        } finally {
            setLoading(false); // Ensure loading is set to false after the delay and fetch
        }
    };

    useEffect(() => {
        fetchClientData();
    }, [clientId, accessToken]);








    if (loading) {
        return <div className="loderDiv">
            <GifLoder />
        </div>;
    }




    return (
        <>
            <Row className='body_content'>
                <Row className='mx-0 justify-content-center'>
                    <Col sm={10} className="mb-4 d-flex justify-content-start align-items-center">
                        <Breadcrumb>
                            <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
                                <i className='pi pi-angle-left'></i> Back
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>Edit Client</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col md={12} lg={10} className='mb-4'>
                        <Card>
                            <Card.Header className="sticky-top bg-white shadow-sm border-0" style={{ top: '-35px', zIndex: 9 }}>
                                <Row className='mx-0 justify-content-between'>
                                    <Col lg='2' md='2' className='position-relative'>
                                        <div className='position-relative' style={{ width: '120px' }}>
                                            <img
                                                src={require("../../assets/images/client-default.png")}
                                                alt=''
                                                style={{ width: '120px', height: '120px' }}
                                                className='rounded-circle bg-light'
                                            />
                                            {/* <FileUpload
                                                mode="basic"
                                                name="profileImage"
                                                auto
                                                className='FlUpload'
                                            /> */}
                                        </div>
                                    </Col>
                                    <Col lg='10' md='10' className='ps-lg-5'>
                                        <ul className="profileformclient">
                                            <li>
                                                <div>
                                                    <span className='font-bold'>Name</span>
                                                    <h6>{clientData.Billing_name}</h6>
                                                </div>
                                            </li>
                                            <li>
                                                <div>
                                                    <span className='font-bold'>Email</span>
                                                    <h6>{clientData.email}</h6>
                                                </div>
                                            </li>
                                            <li>
                                                <div>
                                                    <span className='font-bold'>Client ID :</span>
                                                    <h6>CLT-{clientData.Client_id}</h6>
                                                </div>
                                            </li>
                                            <li>
                                                <div>
                                                    <span className='font-bold'>Registered On</span>
                                                    <h6>{new Date(clientData.createdAt).toLocaleDateString('en-GB')}</h6>
                                                </div>
                                            </li>
                                        </ul>
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body className="billingdetails pb-0">

                                <form onSubmit={handleFormSubmit}>
                                    <div className="d-flex justify-content-between align-items-center pb-2 mb-4">
                                        <h6>Billing Details</h6>
                                        <div>
                                            {editMode && (
                                                <Button
                                                    icon="pi pi-times"
                                                    label="Close"
                                                    severity="danger"
                                                    onClick={toggleEditMode} // This function disables edit mode
                                                    type="button"
                                                    text
                                                    className="me-2"
                                                />
                                            )}
                                            <Button
                                                icon={editMode ? "pi pi-save" : "pi pi-user-edit"}
                                                label={editMode ? "Save" : "Edit"}
                                                severity={editMode ? "success" : "help"}
                                                onClick={editMode ? handleFormSubmit : toggleEditMode}
                                                type="button"
                                                text
                                            />
                                        </div>
                                    </div>
                                    {clientDetails.map((detail, index) => (
                                        <Row key={index} className='p-4 position-relative'>
                                            <div className='rowCount'>
                                                {index + 1}
                                            </div>
                                            {editMode && (
                                                <Col lg="12" className="d-flex justify-content-end mb-3">
                                                    <Button
                                                        icon="pi pi-trash"
                                                        severity="danger"
                                                        title="Delete"
                                                        onClick={() => handleDeleteDetail(index)}
                                                        text
                                                    />
                                                </Col>
                                            )}
                                            <Col lg="4" md="6" className="mb-3 ps-lg-0">
                                                <label htmlFor="comp_name">Company Name:</label>
                                                <InputText
                                                    value={detail.comp_name}
                                                    onChange={(e) =>
                                                        handleInputChange(index, "comp_name", e.target.value)
                                                    }
                                                    required
                                                    disabled={!editMode}
                                                />
                                            </Col>
                                            <Col lg="4" md="6" className="mb-3">
                                                <label htmlFor="bill_name">Billing Name:</label>
                                                <InputText
                                                    value={detail.bill_name}
                                                    onChange={(e) =>
                                                        handleInputChange(index, "bill_name", e.target.value)
                                                    }
                                                    required
                                                    disabled={!editMode}
                                                />
                                            </Col>
                                            <Col lg="4" md="6" className="mb-3">
                                                <label htmlFor="poc">POC:</label>
                                                <InputText
                                                    value={detail.poc}
                                                    onChange={(e) => handleInputChange(index, "poc", e.target.value)}
                                                    required
                                                    disabled={!editMode}
                                                />
                                            </Col>

                                            <Col lg="4" md="6" className="mb-3">
                                                <label htmlFor="gstin">GSTIN:</label>
                                                <InputText
                                                    value={detail.gstin || ""}
                                                    onChange={(e) => handleInputChange(index, "gstin", e.target.value)}
                                                    disabled={!editMode}
                                                />
                                            </Col>
                                            <Col lg="4" md="6" className="mb-3">
                                                <label htmlFor="pan">PAN:</label>
                                                <InputText
                                                    value={detail.pan || ""}
                                                    onChange={(e) => handleInputChange(index, "pan", e.target.value)}
                                                    disabled={!editMode}
                                                />
                                            </Col>
                                            <Col lg="4" md="6" className="mb-3">
                                                <label htmlFor="phone">Phone:</label>
                                                <InputText
                                                    value={detail.phone}
                                                    onChange={(e) => handleInputChange(index, "phone", e.target.value)}
                                                    required
                                                    disabled={!editMode}
                                                />
                                            </Col>
                                            <Col lg="4" md="6" className="mb-3">
                                                <label htmlFor="email">Email:</label>
                                                <InputText
                                                    value={detail.email}
                                                    onChange={(e) => handleInputChange(index, "email", e.target.value)}
                                                    required
                                                    disabled={!editMode}
                                                />
                                            </Col>
                                            <Col lg="4" md="6" className="mb-3">
                                                <label htmlFor="bcc_emails">Bcc Email:</label>
                                                <InputText
                                                    value={detail.bcc_emails || ""}
                                                    onChange={(e) =>
                                                        handleInputChange(index, "bcc_emails", e.target.value)
                                                    }
                                                    disabled={!editMode}
                                                />
                                            </Col>
                                            <Col lg="4" md="6" className="mb-3">
                                                <label htmlFor="cc_emails">CC Email:</label>
                                                <InputText
                                                    value={detail.cc_emails || ""}
                                                    onChange={(e) =>
                                                        handleInputChange(index, "cc_emails", e.target.value)
                                                    }
                                                    disabled={!editMode}
                                                />
                                            </Col>


                                            <Col lg="12" md="12">
                                                <label htmlFor="bill_address">Address</label>
                                                <InputTextarea
                                                    name="bill_address"
                                                    autoResize
                                                    value={detail.bill_address}
                                                    onChange={(e) =>
                                                        handleInputChange(index, "bill_address", e.target.value)
                                                    }
                                                    required
                                                    rows={2}
                                                    className="h-auto"
                                                    placeholder="Address"
                                                    maxLength={120}
                                                    disabled={!editMode}
                                                />
                                                {editMode && (
                                                    <small className='text-muted' style={{ fontSize: '11px', lineHeight: '1' }}>
                                                        ({detail.bill_address.length}/120 characters Max length)
                                                    </small>
                                                )}
                                            </Col>
                                        </Row>
                                    ))}
                                </form>
                            </Card.Body>
                            <Card.Footer className="billingdetails sticky-bottom bg-white py-2 text-end">

                                {editMode && (

                                    <Button
                                        icon="pi pi-plus"
                                        severity="info"
                                        label="Add"
                                        onClick={handleAddNewDetail}
                                        className='py-2'
                                    />

                                )}


                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </Row>
            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

        </>
    );
};

export default Edit_client;